
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Слой 1","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M120.48 6.16c-9.16-8.54-24-8.11-33 1L34.15 60.49c-2.9 2.9-4.41 7.61-6.15 13.07-2.14 6.7-4.57 14.31-10.14 19.89L3.32 108a12.13 12.13 0 000 16.7 11.83 11.83 0 008.34 3.3 11.82 11.82 0 008.34-3.29l14.54-14.56c5.58-5.6 13.17-8 19.87-10.15 5.41-1.72 10.08-3.21 12.94-6.08L121.1 40.1a23.6 23.6 0 00-.62-33.94zM17.17 121.88a7.8 7.8 0 01-5.51 2.12 7.8 7.8 0 01-5.51-2.14 8.24 8.24 0 010-11l10.6-10.62 11 11zm101.1-84.61L64.53 91.1c-2.18 2.18-6.42 3.53-11.33 5.09-6.78 2.16-15.2 4.81-21.49 11.13l-1.11 1.11-11-11 1.11-1.11C27 90 29.65 81.56 31.81 74.77c1.59-5 2.95-9.23 5.17-11.45L90.26 10a20.33 20.33 0 0114.37-6 19.12 19.12 0 0113.12 5.08 19.59 19.59 0 01.52 28.18z"}}),_c('path',{attrs:{"d":"M79.52 67a2 2 0 01-1.42-.59l-16.62-16.6a2 2 0 010-2.83l33.24-33.29a2.06 2.06 0 012.83 0l16.62 16.65a2 2 0 010 2.83L80.93 66.45a2 2 0 01-1.41.55zM65.73 48.4l13.79 13.81 30.41-30.46-13.79-13.81z"}})])
          )
        }
      }
    